export const SESSION_INVALIDATED_EVENT = "auth:session-invalidated";

export const clearStoredSession = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("user-id");
    localStorage.removeItem("user-login");
    localStorage.removeItem("user-password");
    localStorage.removeItem("user-email");
};

export const notifySessionInvalidated = () => {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent(SESSION_INVALIDATED_EVENT));
    }
};

export const invalidateStoredSession = () => {
    clearStoredSession();
    notifySessionInvalidated();
};
